import { useCallback, useEffect } from "react";

const clearGanttSelection = (ganttApi) => {
	// SVAR keeps selected task IDs in its data store, separate from page selection.
	const store = ganttApi?.getStores?.().data;
	store?.setStateAsync?.({ selected: [] });
};

export const applyGanttServiceSelection = (previous, service, toggle) => {
	if (!service) return [];
	if (!toggle) return [service];

	return previous.some((selected) => selected.id === service.id)
		? previous.filter((selected) => selected.id !== service.id)
		: [...previous, service];
};

const useGanttServiceSelection = ({
	ganttApi,
	tasks,
	onServiceSelect,
	filters,
	refreshRevision,
}) => {
	useEffect(() => {
		clearGanttSelection(ganttApi);
	}, [ganttApi, filters, refreshRevision]);

	return useCallback(
		(taskId, toggle) => {
			const task = tasks.find((item) => item.id === taskId);
			const service = task?.serviceData || null;

			if (!service) clearGanttSelection(ganttApi);
			onServiceSelect?.(service, toggle);
		},
		[ganttApi, onServiceSelect, tasks],
	);
};

export default useGanttServiceSelection;
